import React, { useEffect } from "react";

const HubspotForm = () => {
  useEffect(() => {
    const loadScript = () => {
      const script = document.createElement("script");
      script.src = "//js.hsforms.net/forms/embed/v2.js";
      script.type = "text/javascript";
      script.charset = "utf-8";
      script.onload = () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: "46247220",
            formId: "be886c63-ebac-4ac1-b75f-c49ea62e872b",
            region: "na1",
            target: "#hubspotForm",
          });
        }
      };
      document.body.appendChild(script);
    };

    loadScript();
  }, []);

  return <div id="hubspotForm"></div>;
};

export default HubspotForm;
